export default __webpack_public_path__ + "static/media/img-0795-greece-full-face.70841281.png";